import { type PermissionKey, usePermissionCheck } from '@/features/conversation';
import type React from 'react';

interface AuthorizeProps {
  conversationId: string;
  permissions: PermissionKey[];
  skipIf?: boolean;
  hiddenIf?: boolean;
  children: React.ReactNode;
}

export const Authorize: React.FC<AuthorizeProps> = ({ conversationId, permissions, hiddenIf, skipIf, children }) => {
  const { hasAnyPermission } = usePermissionCheck(conversationId);
  const hasRequiredPermission = hasAnyPermission(permissions);

  if (hiddenIf || !(hasRequiredPermission || skipIf)) {
    return null;
  }

  return <>{children}</>;
};
